import { render, staticRenderFns } from "./Indigo.vue?vue&type=template&id=cf6b8e48&scoped=true&"
import script from "./Indigo.vue?vue&type=script&lang=js&"
export * from "./Indigo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf6b8e48",
  null
  
)

export default component.exports